import { IconButton, SvgIcon, Tooltip, styled } from "@mui/material";

const DISCORD_URL = "https://t.co/ojPr0mFAdj";

const Footer = styled("footer")`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    margin-top: -4px;
`;

const DiscordLink = styled(IconButton)`
    color: rgba(255, 255, 255, 0.55);
    padding: 4px;

    &:hover {
        color: #fff;
        background: #5865f2;
    }
` as typeof IconButton;

const DiscordIcon = (): JSX.Element => (
    <SvgIcon sx={{ fontSize: 18 }} viewBox="0 0 24 24">
        <path d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4c-.19.33-.42.78-.58 1.13a17.4 17.4 0 0 0-4.76 0C9.5 4.78 9.26 4.33 9.08 4c-1.51.26-2.95.71-4.28 1.33C2.15 9.22 1.43 13 1.79 16.72c1.78 1.31 3.5 2.11 5.19 2.64.42-.59.81-1.21 1.14-1.86-.65-.24-1.27-.54-1.87-.89l.45-.34c3.61 1.66 7.53 1.66 11.1 0l.45.34c-.6.36-1.25.65-1.88.89.33.65.71 1.27 1.13 1.86 1.69-.53 3.42-1.33 5.2-2.64.43-4.31-.74-8.05-3.43-11.39ZM8.52 14.42c-1.08 0-1.97-.98-1.97-2.19 0-1.2.87-2.18 1.97-2.18 1.11 0 2 .99 1.98 2.18 0 1.21-.87 2.19-1.98 2.19Zm7.01 0c-1.09 0-1.98-.98-1.98-2.19 0-1.2.87-2.18 1.98-2.18s2 .99 1.97 2.18c0 1.21-.86 2.19-1.97 2.19Z" />
    </SvgIcon>
);

const SiteFooter = (): JSX.Element => (
    <Footer aria-label="Social links">
        <Tooltip title="Discord">
            <DiscordLink
                component="a"
                href={DISCORD_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Discord"
            >
                <DiscordIcon />
            </DiscordLink>
        </Tooltip>
    </Footer>
);

export default SiteFooter;
